import RichText from '@onclicks/sharedcomponents/RichText'
import { cn } from '@onclicks/utilities/ui'
import React from 'react'

import type { ContentBlock as ContentBlockType } from '@onclicks/payload-types'

import { CMSLink } from '../../components/CMSLink'
import { courierPrime, quicksand } from '@onclicks/utilities/fontImport'

export const DefaultContent: React.FC<ContentBlockType> = (props) => {
  const { columns } = props

  const colsSpanClasses = {
    full: 'lg:col-span-12',
    half: 'lg:col-span-6',
    oneThird: 'lg:col-span-4',
    twoThirds: 'lg:col-span-8',
  }

  return (
    <div className="px-6 lg:px-30">
      <div className="grid grid-cols-4 lg:grid-cols-12 gap-y-8 gap-x-16 items-center">
        {columns &&
          columns.length > 0 &&
          columns.map((col, index) => {
            const { title, subtitle, enableLink, link, richText, size, links } = col

            return (
              <div
                className={cn(`lg:pt-5 col-span-4 ${colsSpanClasses[size!]}`, {
                  'md:col-span-2': size !== 'full',
                })}
                key={index}
              >
                {title && (
                  <h1 className={cn('text-center font-bold text-4xl mb-1', courierPrime.className)}>
                    {title}
                  </h1>
                )}
                {subtitle && (
                  <h2
                    className={cn(
                      'text-center uppercase text-xl mt-2 mb-8 font-bold',
                      quicksand.className,
                    )}
                  >
                    {subtitle}
                  </h2>
                )}
                {richText && (
                  <RichText
                    data={richText}
                    enableGutter={false}
                    className={cn(`text-center my-5 font-bold uppercase`, courierPrime.className)}
                  />
                )}

                {enableLink && (
                  <div className="w-full flex lg:justify-end pb-5 lg:pb-0">
                    <CMSLink {...link} />
                  </div>
                )}

                {links && links.length > 0 && (
                  <div className="flex justify-center gap-x-8 pb-10">
                    {links.map((link, index) => (
                      <CMSLink key={index} {...link.link} />
                    ))}
                  </div>
                )}
              </div>
            )
          })}
      </div>
    </div>
  )
}
